import { twMerge } from 'tailwind-merge';
import { LinkableCard } from '../LinkableCard';

interface StatsCardProps {
  linkTo?: string;
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  number: number;
  icon?: React.ReactNode;
  disabled?: boolean;
  containerClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  numberClassName?: string;
}

export const StatsCard = ({
  linkTo = '',
  title,
  description,
  number,
  icon,
  disabled,
  containerClassName,
  titleClassName,
  descriptionClassName,
  numberClassName,
}: StatsCardProps) => {
  return (
    <LinkableCard
      linkTo={disabled ? '' : linkTo}
      containerClassName={twMerge(
        'min-w-[296px] flex-row flex-wrap',
        disabled && 'hover:cursor-not-allowed',
        containerClassName
      )}
    >
      <div className="flex flex-1 flex-col">
        <div className={twMerge('text-gray-99A1B6 text-sm', titleClassName)}>
          {title}
        </div>
        {description && (
          <div
            className={twMerge(
              'mt-0.5 font-thin text-xs',
              descriptionClassName
            )}
          >
            {description}
          </div>
        )}
        <div
          className={twMerge('mt-2 text-2xl font-semibold', numberClassName)}
        >
          {number}
        </div>
      </div>
      {icon && <div>{icon}</div>}
    </LinkableCard>
  );
};
